var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import React, { useState, useEffect, } from "react";
import { NSSpecies } from "@gw/types";
import { ModalFilterStyled, ButtonsContainer } from "./ModalFilterStyled";
var ModalFilter = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    var modalId = _a.modalId, closeModal = _a.closeModal, data = _a.data, submitFilter = _a.submitFilter, filters = _a.filters, resetCallback = _a.resetCallback, resetMap = _a.resetMap, handleZoom = _a.handleZoom;
    var _s = useState(data), filteredData = _s[0], setFilteredData = _s[1];
    var _t = useState((_b = data.length) !== null && _b !== void 0 ? _b : 0), results = _t[0], setResults = _t[1];
    var _u = useState(filters), newFilter = _u[0], setNewFilter = _u[1];
    useEffect(function () {
        var locationChecker = function (arr, target) {
            switch (target[0]) {
                case "alaska":
                    if (arr.includes("AK")) {
                        return true;
                    }
                    return false;
                case "others":
                    if (!arr.includes("AK")) {
                        return true;
                    }
                    return false;
                default:
                    return true;
            }
        };
        var speciesChecker = function (arr, target) {
            return target.every(function (v) { return arr.includes(v); });
        };
        var stabilityChecker = function (arr, target) {
            var cleanArray = arr.map(function (item) { return __spreadArray([], item.split(",")); });
            var stabilityConcat = Array.from(new Set(cleanArray.flat()));
            return target.every(function (v) { return stabilityConcat === null || stabilityConcat === void 0 ? void 0 : stabilityConcat.includes(v); });
        };
        var yieldChecker = function (arr, target) {
            return target.some(function (v) {
                var _a = v.split("-"), min = _a[0], max = _a[1];
                return arr.some(function (value) {
                    return Number(value) >= Number(min) && Number(value) <= Number(max);
                });
            });
        };
        var filtered = data
            .filter(function (item) {
            var _a;
            return ((_a = newFilter.location) === null || _a === void 0 ? void 0 : _a.length) > 0
                ? locationChecker([item.state || ""], newFilter.location)
                : true;
        })
            .filter(function (item) {
            var _a;
            return ((_a = newFilter.species) === null || _a === void 0 ? void 0 : _a.length) > 0
                ? speciesChecker(item.species_data.map(function (item) { return item.species; }), newFilter.species)
                : true;
        })
            .filter(function (item) {
            var _a;
            return ((_a = newFilter.yield) === null || _a === void 0 ? void 0 : _a.length) > 0
                ? yieldChecker(item.species_data.map(function (item) {
                    return item.yield.toString();
                }), newFilter.yield)
                : true;
        })
            .filter(function (item) {
            var _a;
            return ((_a = newFilter.stability) === null || _a === void 0 ? void 0 : _a.length) > 0
                ? stabilityChecker(item.species_data.map(function (item) { return "" + item.stability; }), newFilter.stability)
                : true;
        })
            .filter(function (item) {
            var _a;
            return ((_a = newFilter.format) === null || _a === void 0 ? void 0 : _a.length) > 0
                ? stabilityChecker(item.species_data.map(function (item) { return "" + item.format; }), newFilter.format)
                : true;
        });
        setFilteredData(filtered);
        setResults(filtered.length);
    }, [data, newFilter]);
    var handleFilter = function (field, value) {
        var _a;
        var currentFilter = newFilter[field];
        if (field === "location") {
            currentFilter.splice(0, currentFilter.length, value);
        }
        else {
            if (currentFilter.includes(value)) {
                currentFilter.splice(currentFilter.indexOf(value), 1);
            }
            else {
                currentFilter.push(value);
            }
        }
        setNewFilter(__assign(__assign({}, newFilter), (_a = {}, _a[field] = currentFilter, _a)));
    };
    var refocusMap = function (area) {
        switch (area) {
            case "alaska":
                handleZoom([60.2008, -144.4937], 5);
                break;
            case "others":
                handleZoom([41.8313, -71.85027], 7);
                break;
            default:
                resetMap();
                break;
        }
    };
    var clearFilter = function () {
        setNewFilter({
            species: [],
            format: [],
            yield: [],
            stability: [],
            location: [],
        });
        refocusMap("all");
    };
    var handleSubmit = function (ev) {
        refocusMap(newFilter.location[0] || "all");
        ev.preventDefault();
        resetCallback();
        submitFilter(newFilter, filteredData);
        closeModal(modalId);
    };
    return (React.createElement(ModalFilterStyled, { onSubmit: function (ev) { return handleSubmit(ev); } },
        React.createElement("div", { className: "content" },
            React.createElement("div", { className: "filter-container" },
                React.createElement("h3", null, "Location"),
                React.createElement("ul", { className: "filter-flex" },
                    React.createElement("li", { className: "filter-radio" },
                        React.createElement("input", { id: "all", name: "location", type: "radio", checked: (_c = newFilter.location) === null || _c === void 0 ? void 0 : _c.includes("all"), onChange: function () { return handleFilter("location", "all"); } }),
                        React.createElement("span", { className: "radio" }),
                        React.createElement("label", { htmlFor: "all", className: "filter-radio__label" },
                            React.createElement("p", null, "All Locations"))),
                    React.createElement("li", { className: "filter-radio" },
                        React.createElement("input", { id: "alaska", name: "location", type: "radio", checked: (_d = newFilter.location) === null || _d === void 0 ? void 0 : _d.includes("alaska"), onChange: function () { return handleFilter("location", "alaska"); } }),
                        React.createElement("span", { className: "radio" }),
                        React.createElement("label", { htmlFor: "alaska", className: "filter-radio__label" },
                            React.createElement("p", null, "Alaska"))),
                    React.createElement("li", { className: "filter-radio" },
                        React.createElement("input", { id: "others", name: "location", type: "radio", checked: (_e = newFilter.location) === null || _e === void 0 ? void 0 : _e.includes("others"), onChange: function () { return handleFilter("location", "others"); } }),
                        React.createElement("span", { className: "radio" }),
                        React.createElement("label", { htmlFor: "others", className: "filter-radio__label" },
                            React.createElement("p", null, "New England"))))),
            React.createElement("div", { className: "filter-container" },
                React.createElement("h3", null, "Species"),
                React.createElement("ul", { className: "filter-grid" }, Object.values(NSSpecies.TKelpSpecies).map(function (species, i) {
                    var _a;
                    return (React.createElement("li", { key: "species-filter-" + species + "-" + i, className: "filter-checkbox" },
                        React.createElement("input", { name: species, type: "checkbox", checked: (_a = newFilter.species) === null || _a === void 0 ? void 0 : _a.includes(species), onChange: function (ev) { return handleFilter("species", ev === null || ev === void 0 ? void 0 : ev.target.name); } }),
                        React.createElement("span", { className: "check" }),
                        React.createElement("label", { className: "filter-checkbox__label" },
                            React.createElement("p", null,
                                NSSpecies.labels.speciesLabels.kelp[species].name,
                                " ",
                                React.createElement("span", { className: "scientific-name" }, NSSpecies.labels.speciesLabels.kelp[species]
                                    .scientificName)))));
                }))),
            React.createElement("div", { className: "filter-container" },
                React.createElement("h3", null, "Yield"),
                React.createElement("ul", { className: "filter-flex" },
                    React.createElement("li", { className: "filter-checkbox" },
                        React.createElement("input", { id: "yieldLessThan1k", name: "yieldLessThan1k", type: "checkbox", checked: (_f = newFilter.yield) === null || _f === void 0 ? void 0 : _f.includes("0-999"), onChange: function () { return handleFilter("yield", "0-999"); } }),
                        React.createElement("span", { className: "check" }),
                        React.createElement("label", { htmlFor: "yieldLessThan1k", className: "filter-checkbox__label" },
                            React.createElement("p", null, "< 1,000 lbs"))),
                    React.createElement("li", { className: "filter-checkbox" },
                        React.createElement("input", { id: "yieldLessThan10k", name: "yieldLessThan10k", type: "checkbox", checked: (_g = newFilter.yield) === null || _g === void 0 ? void 0 : _g.includes("1000-10000"), onChange: function () { return handleFilter("yield", "1000-10000"); } }),
                        React.createElement("span", { className: "check" }),
                        React.createElement("label", { htmlFor: "yieldLessThan10k", className: "filter-checkbox__label" },
                            React.createElement("p", null, "1k - 10k lbs"))),
                    React.createElement("li", { className: "filter-checkbox" },
                        React.createElement("input", { id: "yieldLessThank50k", name: "yieldLessThank50k", type: "checkbox", checked: (_h = newFilter.yield) === null || _h === void 0 ? void 0 : _h.includes("10000-50000"), onChange: function () { return handleFilter("yield", "10000-50000"); } }),
                        React.createElement("span", { className: "check" }),
                        React.createElement("label", { htmlFor: "yieldLessThank50k", className: "filter-checkbox__label" },
                            React.createElement("p", null, "10k - 50k lbs"))))),
            React.createElement("div", { className: "filter-container" },
                React.createElement("h3", null, "Stability"),
                React.createElement("ul", { className: "filter-flex" },
                    React.createElement("li", { className: "filter-checkbox" },
                        React.createElement("input", { id: "dried", name: "dried", type: "checkbox", checked: (_j = newFilter.stability) === null || _j === void 0 ? void 0 : _j.includes("dried"), onChange: function () { return handleFilter("stability", "dried"); } }),
                        React.createElement("span", { className: "check" }),
                        React.createElement("label", { htmlFor: "dried", className: "filter-checkbox__label" },
                            React.createElement("p", null, "Dried"))),
                    React.createElement("li", { className: "filter-checkbox" },
                        React.createElement("input", { id: "fresh", name: "fresh", type: "checkbox", checked: (_k = newFilter.stability) === null || _k === void 0 ? void 0 : _k.includes("fresh"), onChange: function () { return handleFilter("stability", "fresh"); } }),
                        React.createElement("span", { className: "check" }),
                        React.createElement("label", { htmlFor: "fresh", className: "filter-checkbox__label" },
                            React.createElement("p", null, "Fresh"))),
                    React.createElement("li", { className: "filter-checkbox" },
                        React.createElement("input", { id: "frozen", name: "frozen", type: "checkbox", checked: (_l = newFilter.stability) === null || _l === void 0 ? void 0 : _l.includes("frozen"), onChange: function () { return handleFilter("stability", "frozen"); } }),
                        React.createElement("span", { className: "check" }),
                        React.createElement("label", { htmlFor: "frozen", className: "filter-checkbox__label" },
                            React.createElement("p", null, "Frozen"))))),
            React.createElement("div", { className: "filter-container" },
                React.createElement("h3", null, "Format"),
                React.createElement("ul", { className: "filter-flex" },
                    React.createElement("li", { className: "filter-checkbox" },
                        React.createElement("input", { id: "blade", name: "blade", type: "checkbox", checked: (_m = newFilter.format) === null || _m === void 0 ? void 0 : _m.includes("blade"), onChange: function () { return handleFilter("format", "blade"); } }),
                        React.createElement("span", { className: "check" }),
                        React.createElement("label", { htmlFor: "blade", className: "filter-checkbox__label" },
                            React.createElement("p", null, "Blade Only"))),
                    React.createElement("li", { className: "filter-checkbox" },
                        React.createElement("input", { id: "stipe", name: "stipe", type: "checkbox", checked: (_o = newFilter.format) === null || _o === void 0 ? void 0 : _o.includes("stipe"), onChange: function () { return handleFilter("format", "stipe"); } }),
                        React.createElement("span", { className: "check" }),
                        React.createElement("label", { htmlFor: "stipe", className: "filter-checkbox__label" },
                            React.createElement("p", null, "Stipe Only"))),
                    React.createElement("li", { className: "filter-checkbox" },
                        React.createElement("input", { id: "whole", name: "whole", type: "checkbox", checked: (_p = newFilter.format) === null || _p === void 0 ? void 0 : _p.includes("whole"), onChange: function () { return handleFilter("format", "whole"); } }),
                        React.createElement("span", { className: "check" }),
                        React.createElement("label", { htmlFor: "whole", className: "filter-checkbox__label" },
                            React.createElement("p", null, "Whole Kelp"))),
                    React.createElement("li", { className: "filter-checkbox" },
                        React.createElement("input", { id: "ground", name: "ground", type: "checkbox", checked: (_q = newFilter.format) === null || _q === void 0 ? void 0 : _q.includes("ground"), onChange: function () { return handleFilter("format", "ground"); } }),
                        React.createElement("span", { className: "check" }),
                        React.createElement("label", { htmlFor: "ground", className: "filter-checkbox__label" },
                            React.createElement("p", null, "Ground Kelp"))),
                    React.createElement("li", { className: "filter-checkbox" },
                        React.createElement("input", { id: "powdered", name: "powdered", type: "checkbox", checked: (_r = newFilter.format) === null || _r === void 0 ? void 0 : _r.includes("powdered"), onChange: function () { return handleFilter("format", "powdered"); } }),
                        React.createElement("span", { className: "check" }),
                        React.createElement("label", { htmlFor: "powdered", className: "filter-checkbox__label" },
                            React.createElement("p", null, "Powdered Kelp")))))),
        React.createElement(ButtonsContainer, null,
            results === 0 && (React.createElement("div", { className: "no-results-popup" }, "There aren't any ocean farms that meet your criteria. Try removing some filters to see farms.")),
            React.createElement("button", { type: "button", className: "clear-button", onClick: clearFilter }, "CLEAR ALL"),
            React.createElement("button", { type: "submit", disabled: results === 0 }, results > 0
                ? "SEE " + results + " RESULT" + (results !== 1 ? "S" : "")
                : "0 RESULTS"))));
};
export default ModalFilter;
//# sourceMappingURL=ModalFilter.js.map